import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import HtmlHead from 'client/components/htmlHead';
import { Tracking } from 'web-core/src/tracking';
import {
  fetchProfessionsIfNeeded,
  fetchPersonalizedProfessions,
  setSelectedProfessions,
  saveProfessions,
} from 'client/actions/tax/professions';
import { fetchCategories } from 'client/actions/tax/expenses';
import LinkButton from 'client/components/button/linkButton';
import Translate from 'client/components/translate';
import Card from 'client/components/card/card';
import SelectionList from 'client/components/list/selectionList/selectionList';
import { ProfessionShape } from 'client/constants/tax/shapes';

const mapStateToProps = state => ({
  professions: state.professions.content,
  selectedProfessionIds: state.professions.selected,
  user: state.user,
});

const propTypes = {
  professions: PropTypes.arrayOf(ProfessionShape),
  selectedProfessionIds: PropTypes.arrayOf(PropTypes.number),
  user: PropTypes.object.isRequired,
  fetchProfessionsIfNeeded: PropTypes.func.isRequired,
  fetchPersonalizedProfessions: PropTypes.func.isRequired,
  setSelectedProfessions: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  location: PropTypes.shape({
    query: PropTypes.shape({
      selected: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string),
      ]),
    }).isRequired,
  }).isRequired,
};

const defaultProps = {
  professions: [],
  selectedProfessionIds: [],
};

class JobSelectorPage extends React.Component {
  UNSAFE_componentWillMount() {
    if (this.props.user.isLoggedIn) {
      this.props.fetchPersonalizedProfessions();
    } else {
      this.props.fetchProfessionsIfNeeded()
        .then((res) => {
          let { selected } = this.props.location.query;
          if (typeof selected === 'string') {
            selected = [selected];
          }

          if (Array.isArray(selected) && Array.isArray(res.content)) {
            const ids = res.content
              .filter(p => selected.indexOf(p.seoSlug) > -1)
              .map(p => p.id);
            this.props.setSelectedProfessions(ids);
          }
        });
    }
  }

  onButtonClick = (e) => {
    e.preventDefault();
    const selected = this.getSelectedProfessions();
    if (!selected.length) {
      return;
    }

    const jobs = selected.map(p => p.name).join(', ');
    Tracking.setPeopleProps({ Jobs: jobs });
    Tracking.track('Deduction Guide: Select Jobs', { Jobs: jobs });
    this.props.router.push(this.getReportUrl());
  };


  getSelectedProfessions = () => this.props.professions.filter(
    p => this.props.selectedProfessionIds.indexOf(p.id) > -1,
  )

  getSelectedParams() {
    return this.getSelectedProfessions().map(p => p.seoSlug);
  }

  getReportUrl() {
    return `/deductions/lookup/${this.getSelectedParams().join('/')}`;
  }

  render() {
    const toggleItems = this.props.professions.map(profession => ({
      id: profession.id,
      title: profession.displayName,
      subtitle: profession.subtitle,
    }));
    const selectedItems = this.getSelectedProfessions();

    return (
      <div className="center-col pad-bottom-2">
        <HtmlHead title="Stride Health - Tax Deduction Guide - Select Jobs">
          <meta
            name="keywords"
            content={this.props.professions.map(p => p.displayName).join(', ')} />
        </HtmlHead>
        <Card className="flush-top flush-small">
          <div>
            <h3 className="text-center margin">
              <Translate path="taxes.deductionGuide.professions.title" />
            </h3>
            <p className="text-center margin-bottom-2">
              <Translate path="taxes.deductionGuide.professions.subtitle" />
            </p>
            <SelectionList
              className="flush"
              allItems={toggleItems}
              selectedItems={selectedItems}
              changeHandler={(newSelectedItems) => {
                this.props.setSelectedProfessions(newSelectedItems.map(i => i.id));
              }} />
            <div className="text-center" style={{ padding: '3rem 1rem 1rem' }}>
              <LinkButton
                href={this.getReportUrl()}
                onClick={this.onButtonClick}
                className={`cta-button auto${selectedItems.length ? '' : ' disabled'}`}>
                <Translate path="taxes.deductionGuide.professions.cta" />
              </LinkButton>
            </div>
          </div>
        </Card>
      </div>
    );
  }
}

JobSelectorPage.propTypes = propTypes;
JobSelectorPage.defaultProps = defaultProps;

export default connect(mapStateToProps, {
  fetchProfessionsIfNeeded,
  fetchPersonalizedProfessions,
  fetchCategories,
  setSelectedProfessions,
  saveProfessions,
})(JobSelectorPage);
